import { Trans } from '@lingui/macro'
import { TableDataContainer } from 'components/Table'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { GridContainer, NoTokensState } from 'pages/Liquidity/Table'
import { AlertTriangle } from 'react-feather'

import { HeaderRow, LoadedRow, LoadingRow } from './AssetRow'

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <LoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE }: { rowCount?: number }) {
  return (
    <GridContainer>
      <HeaderRow />
      <TableDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TableDataContainer>
    </GridContainer>
  )
}

export interface AssetListProps {
  assetList: any
}
export default function TokenTable({ assetList }: AssetListProps) {
  const loadingAssets = false

  /* loading and error state */
  if (loadingAssets && !assetList) {
    return <LoadingTokenTable rowCount={5} />
  } else if (!assetList) {
    return (
      <NoTokensState
        thRow={<HeaderRow />}
        message={
          <>
            <AlertTriangle size={16} />
            <Trans>An error occurred loading assetList. Please try again.</Trans>
          </>
        }
      />
    )
  } else if (assetList?.length === 0) {
    return <NoTokensState thRow={<HeaderRow />} message={<Trans>No assetList found</Trans>} />
  } else {
    return (
      <>
        <HeaderRow />
        <TableDataContainer>
          {assetList.map((asset: any, index: number) => (
            <LoadedRow key={index} assetListIndex={index} assetListLength={assetList.length} asset={asset} />
          ))}
        </TableDataContainer>
      </>
    )
  }
}
